export const CATEGORY_SUGGESTIONS = [
  'CLINICAL RECORDS',
  'NURSING RECORDS',
  'CARE PLANS',
  'CHARTS AND ASSESSMENTS',
  'RISK ASSESSMENTS',
  'FALLS ASSESSMENT',
  'TISSUE VIABILITY',
  'PRESSURE AREA',
  'CORRESPONDENCE',
  'GP RECORDS',
  'INVESTIGATIONS/RESULTS',
  'BLOOD RESULTS',
  'RADIOLOGY',
  'IMAGING',
  'THEATRE',
  'MRI',
  'LLOYD GEORGE',
  'CT',
  'COMPUTERISED RECORDS',
  'ULTRASOUND',
  'HISTOLOGY',
  'MICROBIOLOGY',
  'PATHOLOGY',
  'ECG',
  'ENDOSCOPY',
  'ACCIDENT AND EMERGENCY',
  'OPERATION',
  'ANAESTHETIC',
  'MATERNITY RECORDS',
  'ANTENATAL',
  'INTRAPARTUM AND LABOUR',
  'POSTNATAL',
  'NEONATAL',
  'INTENSIVE CARE',
  'REHABILITATION',
  'PHYSIOTHERAPY',
  'DIALYSIS',
  'PAEDIATRICS',
  'DISCHARGE',
  'CANCER CARE',
  'MENTAL HEALTH',
  'DENTAL',
  'DIAGNOSTICS',
  'DRUG CHARTS',
  'CONSENT',
  'DATIX / INCIDENT',
  'COMPLAINT',
  'AMBULANCE',
  'MDT (MULTIDISCIPLINARY TEAM)',
  'VITAL SIGNS',
  'PHOTOGRAPHS',
  'SAFEGUARDING',
  'PATIENT ADMISSION',
  'SOCIAL WORK',
  'MISCELLANEOUS',
  'BLANK / DUPLICATE',
  'OPHTHALMOLOGY',
  'BIOCHEMISTRY',
  'HAEMATOLOGY',
  'HISTOPATHOLOGY',
  'TRACHEOSTOMY',
  'CANNULATION',
  'SKIN CHECK',
  'FLUID BALANCE',
  'DIETETICS',
  'EXPERT REPORT',
  'CTG',
];
